import NotificationsSideBar from './NotificationsSideBar';

export default NotificationsSideBar;
